import { Typography } from "@mui/material";
import { Grid } from "@mui/material";
import { Header } from "gf-ui-components-mui-lib";
import { Moon, Notification, Globe, Contact, Sun, Logout } from "@/icons";
import { useAuth } from "@/hooks/auth.hooks";
import { getCookie } from "@/utils";
import Breadcrumb from "./Breadcrumb";

const HeaderLayout = ({ toggleTheme, customTheme }: any) => {
  const { handleLogout, loggedUser } = useAuth();
  const domainName = getCookie("xsm_user_domain");
  const loginDomainName = getCookie("xsm_user_domain");
  const isAdminAccess = getCookie("xsm_admin_access") ?? "";

  const controls_data = [
    {
      id: "theme",
      label: "Theme",
      icon: customTheme === "light" ? <Moon /> : <Sun />,
      handleControl: () => toggleTheme()
    },
    {
      id: "notification",
      label: "Notification",
      icon: <Notification />
    }
  ];

  const menuitems = [
    {
      id: "logout",
      label: "Exit",
      icon: <Logout />,
      handleItem: () => handleLogout({ redirectToLogoutEndpoint: false })
    }
  ];

  return (
    <Header
      {...{
        position: "fixed",
        color: "inherit",
        searchBar: false,
        controls: controls_data,
        user: isAdminAccess ? "admin" : loggedUser?.first_name ?? "",
        menuItems: menuitems,
        createDomain: true,
        xsmadmin: true,
        adminIcon: <Contact />,
        children: (
          <div style={{ paddingLeft: "56px" }}>
            <Breadcrumb separableicon={true} />
          </div>
        ),
        chipChild: (
          <Grid
            sx={{
              backgroundColor: "#fff",
              color: "black",
              gap: "8px",
              padding: "4px 8px",
              borderRadius: "10px",
              width: "auto",
              border: "1px solid #E6E6E6"
            }}
            className="head-dom-name"
          >
            <Grid display={"flex"}>
              <Globe />
              <Typography
                ml={1}
                fontSize={"16px"}
                fontWeight={400}
                lineHeight={"24px"}
                fontFamily={"Poppins"}
              >
                {loginDomainName}
              </Typography>
            </Grid>
          </Grid>
        ),
        sx: {
          boxShadow: "none",
          zIndex: "10",
          height: "86px",
          justifyContent: "center",
          width: "100%",
          padding: "0px",
          paddingRight: "32px",
          "& .MuiToolbar-root": {
            padding: "0px !important"
          },
          "& .MuiIconButton-edgeEnd": {
            paddingRight: "16px"
          }
        }
      }}
    />
  );
};

export default HeaderLayout;
